import { unstable_setRef as setRef } from '@mui/utils';
export default setRef;


// WEBPACK FOOTER //
// ./node_modules/@mui/material/utils/setRef.js